// Allowlist redirect validation — only *.jensen-dowell.me (SCOPE.md §12 + SCOPE.md §4.1)
const ALLOWED_HOST_PATTERN = /^([a-zA-Z0-9-]+\.)*jensen-dowell\.me$/;

export function isValidRedirect(url: string): boolean {
  try {
    const parsed = new URL(url);
    return (
      (parsed.protocol === "https:" || parsed.protocol === "http:") &&
      ALLOWED_HOST_PATTERN.test(parsed.hostname)
    );
  } catch {
    return false;
  }
}
